import { connect, useSelector } from 'react-redux'
import { logout } from '../actions/authenticationActions'
import { isLoggedIn } from '../services/authenticationService'
import { useIdleTimer } from 'react-idle-timer'

const IdleTimeout = ({ dispatch }) => {

  const IDLE_TIME_OUT = 1000 * 60 * 30 //30 min
  let opportunity = useSelector((state) => state.opportunity)

  const handleOnIdle = (event) => {
    logoutHandler()
  }

  useIdleTimer({
    timeout: IDLE_TIME_OUT,
    onIdle: handleOnIdle,
    debounce: 500,
  })

  const logoutHandler = (e) => {
    let opportunityId = opportunity && opportunity.opportunityId

    e && e.preventDefault()
    dispatch(logout())
    if (opportunityId) {
      window.location.href = '/login?oppId=' + opportunityId
    } else {
      window.location.href = '/login'
    }
  }

  return isLoggedIn() ? (
    <></>
  ) : null

}

export default connect()(IdleTimeout)
